<div class="gallery_items">
  <div class="hvrbox" id="VKHeader">
    <img src="" alt="" class="hvrbox-layer_bottom">
    <div class="hvrbox-layer_top">
      <div class="hvrbox-text"></div>
    </div>
  </div>
  <div class="hvrbox" id="Argamach-Christmas">
    <img src="" alt="" class="hvrbox-layer_bottom">
    <div class="hvrbox-layer_top">
      <div class="hvrbox-text"></div>
    </div>
  </div>
</div>
